import { useEffect } from "react";

type WindowWithGtag = Window &
  typeof globalThis & {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };

const GA_ID = import.meta.env.VITE_GA_ID;

function GoogleAnalytics() {
  useEffect(() => {
    if (!GA_ID || typeof window === "undefined") {
      return;
    }

    const win = window as WindowWithGtag;

    if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${GA_ID}"]`)) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);
    }

    win.dataLayer = win.dataLayer || [];
    win.gtag =
      win.gtag ||
      function gtag() {
        win.dataLayer?.push(arguments);
      };

    win.gtag("js", new Date());
    win.gtag("config", GA_ID);
  }, []);

  return null;
}

export default GoogleAnalytics;
